import ReducerBuilder from 'classes/ReducerBuilder';
import {Types as DateRangeActionTypes} from './actions';

const initialState = Object.freeze({
  isOpen: false
});

export default ReducerBuilder.make(initialState)
  .forType(DateRangeActionTypes.OPEN_MODAL)
  .reduce((state, action) => {
    state.isOpen = true;
  })
  .forType(DateRangeActionTypes.CLOSE_MODAL)
  .reduce((state, action) => {
    state.isOpen = false;
  })
  .build();



// WEBPACK FOOTER //
// ./public/components/DateRange/reducer.js